export default "/packs/images/Rosaria~c7b6536a09f1e3059a43e1f18ba7e9ec.jpg";